<!-- 券種選択Select欄 -->
<template>
  <div class="field">
    <!-- ラベル -->
    <label> 券種 </label>
    <!-- ラベル -->

    <!-- 券種選択Select -->
    <div class="select-wrap">
      <select
        v-model="selectedMasterBookId"
        class="form-control"
        @change="onSelected(selectedMasterBookId)"
      >
        <!-- 券種を選択してください -->
        <option :value="0">券種を選択してください</option>

        <!-- stationsをループ表示 -->
        <option
          v-for="(feature, index) in features"
          :key="index"
          :value="feature.id"
        >
          {{ feature.name }}
        </option>
      </select>
    </div>
    <!-- 券種選択Select -->
  </div>
</template>

<script>
import { ref } from "vue";

export default {
  name: "MbFeatureSelect",
  props: {
    features: {
      type: Array,
      required: true,
    },
    onSelected: {
      type: Function,
      required: true,
    },
  },
  setup() {
    const selectedMasterBookId = ref(0);

    return {
      selectedMasterBookId,
    };
  },
};
</script>

<style lang="scss" scoped>
.field {
  position: relative;
  margin: 0 0 15px 0;
}

label {
  position: absolute;
  width: 150px;
  z-index: 100;
  top: 0;
  margin-top: 15px;
  margin-left: 15px;
  font-size: 13px;
  color: #888888;
}

/* セレクトボックス */
select {
  -webkit-appearance: none;
  width: 100%;
  height: 42px;
  margin-bottom: 0;
  border: 1px solid #e0e0e0;
  border-radius: 0;
  background-color: #ffffff;
  outline: none;
  padding: 5px 30px 5px 60px;
  font-size: 16px;
  line-height: 20px;
  font-weight: bold;
  color: #000000;
}

select:focus {
  border-color: #e0e0e0;
}

.select-wrap {
  width: 100%;
  position: relative;
  display: inline-block;
  border-radius: 0;
}

.select-wrap::after {
  content: "";
  width: 6px;
  height: 6px;
  border: 0px;
  border-bottom: solid 2px #b4b3b3;
  border-right: solid 2px #b4b3b3;
  -ms-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  position: absolute;
  top: 20px;
  right: 15px;
  margin-top: -6px;
}
</style>
